// Types
import { IconProps } from 'component-library/icon'

export interface Link {
  name: string
  link: string
}

export interface Media {
  icon: IconProps['name'],
  link: string
}

export const dataMedias: Media[] = [
  {
    icon: 'youtube',
    link: 'https://www.youtube.com/user/ProENEMOficial'
  },
  {
    icon: 'spotify',
    link: 'https://open.spotify.com/show/6prfXbOrIk2UtLv6KPclUV'
  },
  {
    icon: 'tiktok',
    link: 'https://www.tiktok.com/@proenemoficial?lang=pt-BR'
  },
  {
    icon: 'facebook',
    link: 'https://pt-br.facebook.com/proenem/'
  },
  {
    icon: 'instagram',
    link: 'https://www.instagram.com/proenem/?hl=pt-br'
  },
  {
    icon: 'twitter',
    link: 'https://x.com/ProEnemOficial'
  }
]

export const dataNossosPlanos: Link[] = [
  {
    name: 'ENEMPRO 2025',
    link: 'https://proenem.com.br/#turmas'
  },
  {
    name: 'ENEMVIP 2025',
    link: 'https://proenem.com.br/#turmas'
  },
  {
    name: 'MEDVIP 2025',
    link: 'https://proenem.com.br/#turmas'
  }
]

export const dataApostilas: Link[] = [
  {
    name: 'Apostilas Enem',
    link: 'https://proenem.com.br/#apostilas'
  },
  {
    name: 'Apostilas MED',
    link: 'https://proenem.com.br/#apostilas'
  }

]

export const dataGeneralLinks: Link[] = [
  {
    name: 'Central de atendimento',
    link: 'https://atendimento.proenem.com.br/'
  },
  { name: 'Termos de uso', link: 'https://proenem.com.br/enem/termos-de-uso/' },
  {
    name: 'Materiais para download',
    link: 'https://www.proenem.com.br/enem/materiais-para-download/'
  }
]

export const address =
  'PROSUCESSO EDUCACAO E TECNOLOGIA LTDA | CNPJ: 20.054.368/0001-40 | Endereço: Av. Almirante Júlio de Sa Bierrenbach, no 200, Jacarepaguá, CEP: 22.775-028 - Rio de Janeiro'
